import { FC, ReactNode } from 'react';
import CopyUrlMenuItem from './copy-url-menu-item';
import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';
import Menu from '../../menu';
import Icon from '../../icon';

interface Props {
  children?: ReactNode;
  hideCopy?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  menu: {
    '& > span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  icon: {
    padding: 2,
    '&:hover': {
      backgroundColor: theme.palette.lightGray,
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const DrawerMenu: FC<Props> = ({ children, hideCopy = false }) => {
  const styles = useStyles();
  return (
    <Menu
      menuId="drawer-menu"
      trigger={<Icon name="more-horiz" className={styles.icon} />}
      className={styles.menu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {!hideCopy && <CopyUrlMenuItem />}
      {children}
    </Menu>
  );
};

export default DrawerMenu;
